import { Captcha } from 'src/types';
import { nzApiAxios } from 'src/utils/nz-axios/nz-axios';

export const subscriptionApiUrl = '/Subscriptions';

const PostSubscriptions = (data: { email: string; status: number } & Captcha): Promise<{ id: string }> =>
  nzApiAxios.post(subscriptionApiUrl, data).then((resp) => resp.data);
const PutSubscriptions = (data: { email: string; status: number } & Captcha): Promise<{ id: string }> =>
  nzApiAxios.put(subscriptionApiUrl, data).then((resp) => resp.data);

const API = {
  subscribeToUpdates: PostSubscriptions,
  unsubscribe: PutSubscriptions
};

export default API;
